function removeTypenameDeep<T>(input: T): T {
  if (Array.isArray(input)) {
    return input.map((item) => removeTypenameDeep(item)) as T;
  }

  if (input !== null && typeof input === "object") {
    const result: any = {};
    for (const [key, value] of Object.entries(input)) {
      if (key === "__typename") continue;
      result[key] = removeTypenameDeep(value);
    }
    return result;
  }

  return input;
}

export { removeTypenameDeep };
